import React from "react";
import { t } from "../i18n";
import { reportExportUrl, batchExportUrl } from "../lib/api";
import { DownloadSimple, FilePdf, FileCsv } from "@phosphor-icons/react";

export default function ExportButtons({ lang, kind, id }) {
  // kind: "report" | "batch"
  const csvUrl = kind === "report" ? reportExportUrl(id, "csv") : batchExportUrl(id, "csv");
  const pdfUrl = kind === "report" ? reportExportUrl(id, "pdf") : batchExportUrl(id, "pdf");

  return (
    <div className="flex items-center gap-0 border border-neutral-900" data-testid={`export-buttons-${kind}`}>
      <span className="px-3 py-1.5 bg-neutral-900 text-white text-[10px] uppercase tracking-widest font-mono inline-flex items-center gap-1.5">
        <DownloadSimple size={12} />
        {t(lang, "export")}
      </span>
      <a
        href={csvUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="border-l border-neutral-900 px-3 py-1.5 text-[10px] uppercase tracking-widest font-mono inline-flex items-center gap-1.5 hover:bg-neutral-100 ma-trans"
        data-testid={`export-${kind}-csv`}
      >
        <FileCsv size={12} />
        {t(lang, "export_csv")}
      </a>
      <a
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="border-l border-neutral-900 px-3 py-1.5 text-[10px] uppercase tracking-widest font-mono inline-flex items-center gap-1.5 hover:bg-neutral-100 ma-trans"
        data-testid={`export-${kind}-pdf`}
      >
        <FilePdf size={12} />
        {t(lang, "export_pdf")}
      </a>
    </div>
  );
}
